import { useEffect, useState } from "react";
import { Eye, CalendarCheck, MessageCircle, Compass } from "lucide-react";
import api from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const METRICS = [
  { key: "visits", label: "Visite al mini-sito", icon: Eye },
  { key: "online", label: "Click \"Verifica on line\"", icon: CalendarCheck },
  { key: "whatsapp", label: "Click WhatsApp", icon: MessageCircle },
  { key: "tours", label: "Click \"Confronta tour ed esperienze\"", icon: Compass },
];
const MONTHS = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

function Filters({ props, pid, setPid, year, setYear, years }) {
  return (
    <div className="flex flex-wrap gap-3 mb-6">
      <Select value={pid || "all"} onValueChange={(v) => setPid(v === "all" ? "" : v)}>
        <SelectTrigger data-testid="report-property-select" className="w-full sm:w-[280px] bg-white"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tutte le strutture</SelectItem>
          {props.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
        <SelectTrigger data-testid="report-year-select" className="w-[120px] bg-white"><SelectValue /></SelectTrigger>
        <SelectContent>
          {years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

function MonthTable({ months }) {
  return (
    <div className="rounded-2xl bg-white border border-brand-plum/8 shadow-sm overflow-x-auto max-w-[calc(100vw-2rem)] sm:max-w-[calc(100vw-3rem)] lg:max-w-none">
      <table className="w-full text-sm" data-testid="report-month-table">
        <thead className="bg-brand-warm/60 text-brand-plum/60">
          <tr><th className="text-left p-3 font-medium">Mese</th>{METRICS.map((m) => <th key={m.key} className="text-right p-3 font-medium whitespace-nowrap">{m.label}</th>)}</tr>
        </thead>
        <tbody>
          {months.map((r) => (
            <tr key={r.month} className="border-t border-brand-plum/5">
              <td className="p-3 text-brand-plum">{MONTHS[r.month - 1]}</td>
              {METRICS.map((m) => <td key={m.key} className="p-3 text-right tabular-nums text-brand-plum/80">{r[m.key]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Report() {
  const now = new Date().getFullYear();
  const [props, setProps] = useState([]);
  const [pid, setPid] = useState("");
  const [year, setYear] = useState(now);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/properties").then((r) => setProps(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    api.get("/admin/reports/events", { params: { year, property_id: pid } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [year, pid]);

  return (
    <AdminLayout title="Report strutture">
      <Filters props={props} pid={pid} setPid={setPid} year={year} setYear={setYear} years={data?.years || [now]} />
      {!data ? <p className="text-brand-plum/40">Caricamento...</p> : (
        <>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-6">
            {METRICS.map((m) => (
              <div key={m.key} className="rounded-2xl bg-white border border-brand-plum/8 shadow-sm p-5" data-testid={`report-total-${m.key}`}>
                <m.icon size={20} className="text-brand-teal mb-3" />
                <p className="font-serif text-3xl text-brand-plum tabular-nums">{data.totals[m.key]}</p>
                <p className="text-xs text-brand-plum/55 mt-1">{m.label}</p>
              </div>
            ))}
          </div>
          <MonthTable months={data.months} />
        </>
      )}
    </AdminLayout>
  );
}
